import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    EncodingUtilities,
    ENDPOINTS,
    HttpUtilitiesService,
    OdataResponse,
    ODataUtilities,
    UriUtilitiesService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ODocBoxUploadModel } from './docBox-odata.interface';
import { ODataSubmitFormPayload, ODataSubmitParticipantCopyPayload } from './forms-write.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataFormsService {
    public constructor(
        @Inject(ClientManagerInstanceToken) protected readonly clientManager: ClientManagerInterface,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly httpUtilities: HttpUtilitiesService,
        private readonly httpClient: HttpClient,
    ) {}

    public deepInsertRequest(
        endpoint: string,
        data: ODataSubmitFormPayload | ODataSubmitParticipantCopyPayload | ODocBoxUploadModel,
        identifier: string,
    ): Observable<unknown> {
        const modifiedEndPoint = ODataUtilities.removeLeadingSlash(endpoint);
        const payload = {
            Endpoint: modifiedEndPoint,
            TimeStamp: `${modifiedEndPoint}-${identifier}`,
            Json: EncodingUtilities.base64EncodeUnicode(JSON.stringify(data)),
        };
        const query = this.uriUtilities.getUriForContent() + ENDPOINTS.DeepInsertSet;

        const headers = this.httpUtilities.setHeadersForIdempotency(
            new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest',
            }),
        );

        return this.httpClient.post<OdataResponse<unknown>>(query, payload, { headers }).pipe(
            map((response) => ODataUtilities.transformResponseDataToArray(response.d)),
            catchError((error) => {
                this.log.error(
                    'deepInsertRequest() - request error: ' +
                        JSON.stringify(error) +
                        ' - for Request: ' +
                        JSON.stringify(endpoint),
                );
                return throwError(error);
            }),
        );
    }
}
